import React, { useEffect, useState } from 'react';
import useReveal from '../../hooks/useReveal';
import './ExpertiseSection.css';

const ExpertiseSection = ({ headerTitle, headerSubtitle, items }) => {
  const [activeItemId, setActiveItemId] = useState(items[0]?.id ?? null);
  const sectionRef = useReveal();
  const activeItem = items.find((item) => item.id === activeItemId) ?? items[0];

  // Warm the remaining images up once the browser is idle, so switching
  // entries feels instant without delaying the initial page load.
  useEffect(() => {
    const warmup = () => {
      items.forEach(({ image }) => {
        const img = new Image();
        img.decoding = 'async';
        img.src = image;
      });
    };

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(warmup, { timeout: 3000 });
      return () => window.cancelIdleCallback(idleId);
    }
    const timeoutId = setTimeout(warmup, 1500);
    return () => clearTimeout(timeoutId);
  }, [items]);

  return (
    <section className="expertise-section reveal" ref={sectionRef}>
      <div className="expertise-section-container">
        <div className="expertise-header">
          <h2>{headerTitle}</h2>
          <p>{headerSubtitle}</p>
        </div>

        <div className="expertise-content">
          <div className="expertise-list">
            {items.map((item) => {
              const isActive = item.id === activeItemId;
              return (
                <div key={item.id} className={`expertise-item ${isActive ? 'active' : ''}`}>
                  <h3 className="expertise-item-heading">
                    <button
                      type="button"
                      className="expertise-item-trigger"
                      aria-expanded={isActive}
                      onClick={() => setActiveItemId(item.id)}
                    >
                      {item.title}
                      <svg
                        className="expertise-item-chevron"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M5.23 7.21a.75.75 0 011.06 0L10 10.92l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 010-1.06z" />
                      </svg>
                    </button>
                  </h3>
                  <div className="expertise-item-body">
                    <div className="expertise-item-body-inner">
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="expertise-image-frame">
            <img
              key={activeItem?.id}
              src={activeItem?.image}
              alt={activeItem?.title || ''}
              className="expertise-image"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
